<div class="page-container">
  <header class="navbar navbar-expand-lg navbar-dark fixed-top nga-navbar">
    <nav class="container p-0 mx-4" aria-label="Main navigation"
      style="max-width: none;">
      <!-- Brand Logo -->
      <a routerLink="/" (click)="goHome()" class="navbar-brand m-r-0" alt="Accueil" aria-label="Gigsumo">
        <img loading="lazy" src="assets/params/images/logo/gigsumologo_bigface.png" srcset="assets/params/images/logo/gigsumologo_bigface.png 1x, 
        assets/params/images/logo/gigsumologo_bigface.png 2x" class="img-ht" alt="Logo Gigsumo">
      </a>

      <!-- Hamburger Icon for Mobile -->
      <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarCollapse"
        aria-controls="navbarCollapse" aria-expanded="false" aria-label="Toggle navigation">
        <span class="navbar-toggler-icon"></span>
      </button>

      <!-- Navbar Links -->
      <div class="collapse navbar-collapse" id="navbarCollapse">
        <ul class="navbar-nav mx-auto mrgn-auto"  *ngIf="!isJobDetail && !isCandidateDetail">
          <li class="nav-item" (mouseenter)="showDropdown()" (mouseleave)="hideDropdown()">
            <div class="custom-dropdown">
              <button class="dropdown-toggle-1" (click)="toggleDropdown()">
                <span class="dropdown-label">Solutions</span>
                <svg class="dropdown-arrow" width="16" height="16" viewBox="0 0 24 24" [class.rotated]="isOpen">
                  <path fill="currentColor" d="M7 10l5 5 5-5z" />
                </svg>
              </button>
              <div class="dropdown-menu" [class.show]="isOpen">
                <a *ngFor="let item of menuItems" [href]="item.route" class="dropdown-item" [class.active]="item.active"
                  (click)="selectItem(item)">
                  {{ item.label }}
                </a>
              </div>
            </div>
          </li>
          <!-- <li class="nav-item price-pos" mat-button>
            <a class="nav-link"  [class.active]="isPricing"  aria-current="page" rel="noopener noreferrer" [routerLink]="['/price']"
              [href]="'/price'">
              Pricing
            </a>
          </li> -->
        </ul>
        <!-- <li class="nav-item">
          <a class="nav-link"   aria-current="page" rel="noopener noreferrer"   href="/web/bench-sales.html">
            Bench Sales
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link"    aria-current="page" rel="noopener noreferrer"   href="/web/job-seekers.html">
            Job Seekers
          </a>
        </li>
        <li class="nav-item">
          <a class="nav-link"  aria-current="page" rel="noopener noreferrer"  href="/web/benefits.html">
            Benefits
          </a>
        </li> -->


        <ul class="navbar-nav me-auto mr-r-0"  *ngIf="!isJobDetail && !isCandidateDetail">

          <li class="nav-item">
            <a class="nav-link"  [class.active]="isJobDetail" aria-current="page" rel="noopener noreferrer" [routerLink]="['/jobs']"
              [href]="'/jobs'">
              Find Job
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" [class.active]="isCandidateDetail" aria-current="page" rel="noopener noreferrer"
              [routerLink]="['/talents']" [href]="'/talents'">
              Find Talent
            </a>
          </li>
          <li class="nav-item">
            <!-- routerLink like Find Job / Find Talent: no full page reload.
                 Loading feedback comes from the directory's own skeleton
                 cards (company.component isLoading), not the browser tab. -->
            <a class="nav-link" [class.active]="isCompanyDirectory" aria-current="page" rel="noopener noreferrer"
              [routerLink]="['/companies']">
              Companies
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" aria-current="page" rel="noopener noreferrer" href="/web/book-a-demo.html">
              Book a Demo
            </a>
          </li>
          <li class="nav-item">
            <a class="nav-link" aria-current="page" rel="noopener noreferrer" href="/web/contact-sale.html">
              Contact Sales
            </a>
          </li>
          
          <!-- <li class="nav-item">
            <a class="btn-primary xtra-dec" aria-current="page" rel="noopener noreferrer" target="_blank"
              href="{{ENVIRONMENT.careOnlineWebUrl}}auth/signUp">
              Sign up for free
            </a>
          </li>           -->
          <li class="nav-item mx-auto">
            <a class="toggle-btn564" aria-current="page" rel="noopener noreferrer" target="_blank"
              href="{{ENVIRONMENT.careOnlineWebUrl}}auth/login">
              Login
            </a>
          </li>
        </ul>
        
        <ul *ngIf="isJobDetail || isCandidateDetail" class="navbar-nav mr-r-0 gj-nav-actions" style="margin-left: auto;">
          <li class="nav-item">
            <a class="gj-nav-btn gj-nav-btn--ghost" aria-current="page" rel="noopener noreferrer" target="_blank"
              href="{{ENVIRONMENT.careOnlineWebUrl}}auth/login">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/><polyline points="17 8 12 3 7 8"/><line x1="12" y1="3" x2="12" y2="15"/></svg>
              <span class="gj-nav-btn-text">Upload Resume</span>
            </a>
          </li>
          <li class="nav-item">
            <a class="gj-nav-btn gj-nav-btn--ghost" aria-current="page" rel="noopener noreferrer" target="_blank"
              href="{{ENVIRONMENT.careOnlineWebUrl}}auth/login">
              Sign in
            </a>
          </li>
          <li class="nav-item">
            <a class="gj-nav-btn gj-nav-btn--primary" aria-current="page" rel="noopener noreferrer" target="_blank"
              href="{{ENVIRONMENT.careOnlineWebUrl}}auth/login">
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" aria-hidden="true"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>
              Post a Job Free
            </a>
          </li>
        </ul>
        
      </div>
    </nav>
  </header>


  <main style="min-height: 505px;">
    <router-outlet></router-outlet>
  </main>

  <footer *ngIf="showFooter" class="footer" [ngClass]="{'rel-pos':isCompanyDirectory || isJobDetail || isCandidateDetail || isMemberDirectory }">
    <!-- Logo Section -->
    <!-- <div class="footer-content"> -->
    <!-- <div class="footer-logo-section">
        <a href="/" class="footer-logo">
          <img loading="lazy" src="/assets/params/images/logo/gigsumologo_final.png" alt="Gigsumo" class="logo-img">
        </a>
      </div> -->

    <!-- Links Sections -->
    <!-- <div class="footer-links-container"> -->
    <!-- Gigsumo For Section -->
    <!-- <div class="footer-section">
          <h3 class="footer-heading">Gigsumo For</h3>
          <ul class="footer-list">
            <li><a href="/web/recruiters.html">Recruiters</a></li>
            <li><a href="/web/bench-sales.html">Bench Recruiters</a></li>
            <li><a href="/web/job-seekers.html">Job Seekers</a></li>
          </ul>
        </div> -->

    <!-- Resources Section -->
    <!-- <div class="footer-section">
          <h3 class="footer-heading">Resources</h3>
          <ul class="footer-list">
            <li><a href="/web/faq.html">FAQs</a></li>
          </ul>
        </div> -->

    <!-- <div class="footer-section">
          <h3 class="footer-heading">Directories</h3>
          <ul class="footer-list">
            <li><a [routerLink]="['/companies']" routerlinkactive class="footer-link-two-2">Companies</a></li>
            <li class="nav-item">
              <a class="nav-link" aria-current="page" rel="noopener noreferrer" [routerLink]="['/jobs']"
                [href]="'/jobs'">
                 Jobs
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" aria-current="page" rel="noopener noreferrer"
                [routerLink]="['/talents']" [href]="'/talents'">
                Talents
              </a>
            </li>
          </ul>
        </div> -->
    <!-- <li><a href="/" class="footer-link-two-2">Jobs</a></li>  -->

    <!-- Company Section -->
    <!-- <div class="footer-section">
          <h3 class="footer-heading">Company</h3>
          <ul class="footer-list">
            <li><a href="/web/about-us.html">About us</a></li>
            <li><a href="/web/benefits.html">Benefits</a></li>
            <li><a href="/web/contact-sale.html">Contact Sales</a></li>
            <li><a href="/web/book-a-demo.html">Book a Demo</a></li>
          </ul>
        </div> -->
    <!-- </div> -->
    <!-- </div> -->

    <!-- Bottom Bar -->
    <div class="footer-bottom">
      <div class="footer-bottom-content footer-bottom-content--nav d-flex justify-content-center">
        <nav class="container p-0" aria-label="Footer navigation">
          <ul class="navbar-nav d-flex flex-row justify-content-center gap-4 list-unstyled m-0 navss">
            <li class="nav-item">
              <a class="nav-link" [class.active]="isJobDetail" aria-current="page" rel="noopener noreferrer"
                [routerLink]="['/jobs']" [href]="'/jobs'">
                Find Jobs
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [class.active]="isCandidateDetail" aria-current="page" rel="noopener noreferrer"
                [routerLink]="['/talents']" [href]="'/talents'">
                Find Talents
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [class.active]="isCompanyDirectory" aria-current="page" rel="noopener noreferrer"
                [routerLink]="['/companies']">
                Find Companies
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" [class.active]="isMemberDirectory" aria-current="page" rel="noopener noreferrer"
                [routerLink]="['/members']" [href]="'/members'">
                Find Members
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" aria-current="page" rel="noopener noreferrer" href="/web/about-us.html">
                About Us
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" aria-current="page" rel="noopener noreferrer" href="/web/faq.html">
                FAQ
              </a>
            </li>
            <li class="nav-item">
              <a class="nav-link" aria-current="page" rel="noopener noreferrer" href="/web/benefits.html">
                Benefits
              </a>
            </li>

          </ul>
        </nav>
      </div>

      <div class="footer-bottom-content footer-bottom-row">
        <!-- Copyright, version, legal flow LEFT; social pushed RIGHT via margin-left:auto -->
        <span class="copyright">© {{currentYear}} <strong>Gigsumo.</strong> All right reserved.</span>
        <span class="version">V.{{versions}}</span>
        <div class="legal-links">
          <a href="/web/privacy-policy.html">Privacy Policy</a><span class="legal-sep" aria-hidden="true">·</span>
          <a href="/web/terms-conditions.html">Terms & Conditions</a><span class="legal-sep" aria-hidden="true">·</span>
          <a href="/web/dmca-policy.html">DMCA Policy</a><span class="legal-sep" aria-hidden="true">·</span>
          <a href="/web/trademark-policy.html">Trademark Policy</a><span class="legal-sep" aria-hidden="true">·</span>
          <a href="/web/acceptable-use-policy.html">Acceptable Use Policy</a>
        </div>

        <!-- Social Media Links -->
        <div class="social-links">
          <a href="https://www.linkedin.com/company/gigsumo/posts/?feedView=all" target="_blank" aria-label="LinkedIn">
            <div class="social-icon w-embed"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M5 3H19C20.1046 3 21 3.89543 21 5V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5C3 3.89543 3.89543 3 5 3ZM8 18C8.27614 18 8.5 17.7761 8.5 17.5V10.5C8.5 10.2239 8.27614 10 8 10H6.5C6.22386 10 6 10.2239 6 10.5V17.5C6 17.7761 6.22386 18 6.5 18H8ZM7.25 9C6.42157 9 5.75 8.32843 5.75 7.5C5.75 6.67157 6.42157 6 7.25 6C8.07843 6 8.75 6.67157 8.75 7.5C8.75 8.32843 8.07843 9 7.25 9ZM17.5 18C17.7761 18 18 17.7761 18 17.5V12.9C18.0325 11.3108 16.8576 9.95452 15.28 9.76C14.177 9.65925 13.1083 10.1744 12.5 11.1V10.5C12.5 10.2239 12.2761 10 12 10H10.5C10.2239 10 10 10.2239 10 10.5V17.5C10 17.7761 10.2239 18 10.5 18H12C12.2761 18 12.5 17.7761 12.5 17.5V13.75C12.5 12.9216 13.1716 12.25 14 12.25C14.8284 12.25 15.5 12.9216 15.5 13.75V17.5C15.5 17.7761 15.7239 18 16 18H17.5Z"
                  fill="CurrentColor"></path>
              </svg></div>
          </a>
          <a href="https://x.com/GigSumoHQ" target="_blank" aria-label="Twitter">
            <div class="social-icon w-embed"><svg xmlns="http://www.w3.org/2000/svg"
                xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="16" height="20" viewBox="0 0 24 24"
                style="enable-background:new 0 0 24 24;" xml:space="preserve">
                <path
                  d="M14.095479,10.316482L22.286354,1h-1.940718l-7.115352,8.087682L7.551414,1H1l8.589488,12.231093L1,23h1.940717  l7.509372-8.542861L16.448587,23H23L14.095479,10.316482z M11.436522,13.338465l-0.871624-1.218704l-6.924311-9.68815h2.981339  l5.58978,7.82155l0.867949,1.218704l7.26506,10.166271h-2.981339L11.436522,13.338465z" />
              </svg></div>
          </a>
          <a href="https://facebook.com" target="_blank" aria-label="Facebook">
            <div class="social-icon w-embed"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M16.5 6H13.5C12.9477 6 12.5 6.44772 12.5 7V10H16.5C16.6137 9.99748 16.7216 10.0504 16.7892 10.1419C16.8568 10.2334 16.8758 10.352 16.84 10.46L16.1 12.66C16.0318 12.8619 15.8431 12.9984 15.63 13H12.5V20.5C12.5 20.7761 12.2761 21 12 21H9.5C9.22386 21 9 20.7761 9 20.5V13H7.5C7.22386 13 7 12.7761 7 12.5V10.5C7 10.2239 7.22386 10 7.5 10H9V7C9 4.79086 10.7909 3 13 3H16.5C16.7761 3 17 3.22386 17 3.5V5.5C17 5.77614 16.7761 6 16.5 6Z"
                  fill="CurrentColor"></path>
              </svg></div>
          </a>
          <a href="https://instagram.com" target="_blank" aria-label="Instagram">
            <div class="social-icon w-embed"><svg width="20" height="20" viewBox="0 0 24 24" fill="none"
                xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd" clip-rule="evenodd"
                  d="M16 3H8C5.23858 3 3 5.23858 3 8V16C3 18.7614 5.23858 21 8 21H16C18.7614 21 21 18.7614 21 16V8C21 5.23858 18.7614 3 16 3ZM19.25 16C19.2445 17.7926 17.7926 19.2445 16 19.25H8C6.20735 19.2445 4.75549 17.7926 4.75 16V8C4.75549 6.20735 6.20735 4.75549 8 4.75H16C17.7926 4.75549 19.2445 6.20735 19.25 8V16ZM16.75 8.25C17.3023 8.25 17.75 7.80228 17.75 7.25C17.75 6.69772 17.3023 6.25 16.75 6.25C16.1977 6.25 15.75 6.69772 15.75 7.25C15.75 7.80228 16.1977 8.25 16.75 8.25ZM12 7.5C9.51472 7.5 7.5 9.51472 7.5 12C7.5 14.4853 9.51472 16.5 12 16.5C14.4853 16.5 16.5 14.4853 16.5 12C16.5027 10.8057 16.0294 9.65957 15.1849 8.81508C14.3404 7.97059 13.1943 7.49734 12 7.5ZM9.25 12C9.25 13.5188 10.4812 14.75 12 14.75C13.5188 14.75 14.75 13.5188 14.75 12C14.75 10.4812 13.5188 9.25 12 9.25C10.4812 9.25 9.25 10.4812 9.25 12Z"
                  fill="CurrentColor"></path>
              </svg></div>
          </a>
        </div>
      </div>
    </div>
  </footer>

</div>